import React, {FC, ReactNode, useMemo} from "react";
import TailSpinLoader from "../TailSpinLoader";

export type IconButtonProps = {
    icon?: ReactNode;
    onClick?: any;
    label?: string;
    title?: string;
    className?: string;
    isLoading?: boolean;
    isDisabled?: boolean;
    hasBackground?: boolean;
};

const IconButton: FC<IconButtonProps> = ({
                                             icon,
                                             onClick,
                                             label,
                                             title,
                                             className,
                                             isLoading,
                                             isDisabled,
                                             hasBackground,
                                         }) => {

    const includesLabel = useMemo(() => !!label, [label]);

    const baseStyle = useMemo(() => {
        const sharedStyle = "  justify-center  flex items-center";
        const labelStyle = includesLabel ? "text-base px-1.5 gap-x-1.5" : "text-lg w-10";
        const additionalStyle = hasBackground && "justify-center  min-w-[52px] rounded-[11px]";
        const backgroundStyle = hasBackground || includesLabel ? "text-text-0 bg-highlight-0 " : "text-highlight-0";

        return `${sharedStyle} ${labelStyle} ${additionalStyle} ${backgroundStyle}`;
    }, [includesLabel, hasBackground]);

    const disabledStyle = useMemo(() =>
            includesLabel || hasBackground
                ? "bg-surface-3 text-text-2"
                : "text-surface-3",
        [includesLabel, hasBackground]
    );

    return (
        <div
            className={`${isDisabled ? disabledStyle : `cursor-pointer ${baseStyle}`} ${className}`}
            title={title}
            onClick={onClick}
        >
            {isLoading ? <TailSpinLoader/> : icon}
            {isLoading ? (label ? "Loading..." : "") : label}
        </div>
    );
};

export default IconButton;
